module.exports = __webpack_public_path__ + "static/media/DSC_0524.70446eac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0524.jpg
// module id = 671
// module chunks = 0